<template>
<div class="" style="padding:0 0 30px 0;">

  <div class="row" >   
    <div class="col s12 m7 offset-m2m yo-align-center ">
      <el-image v-if="typeof $evento.profile != 'undefined'" style="width: 100%; height: 240px" :src="'/images/'+$evento.profile.row.id+'/head.png'" fit="contain" />
      

      <!-- <h2>ABSTRACT MANAGEMENT ACCESS</h2>-->
    </div>
    <div class="col s12 m10 offset-m1m yo-line-3-1" >
      <br /><br />
      Welcome to the ABSTRACT MANAGEMENT ACCESS.
      <br /><br />
      To send an abstract you first need to <strong>register to the portal and receive your credentials</strong>. 
      <br /><br />
      You can create a personal profile clicking on the button: NEW REGISTRATION
      <br /><br />
      Technical note: if you do not receive an email within a few minutes of registration, we suggest that you <strong>check your junk mail</strong>, as messages may be blocked in case you have a spam filter. 
      <br /><br />
      To login you must enter your EMAIL ADDRESS and your PASSWORD and click on the button "LOGIN"
    </div>
  </div>


  <el-form ref="form" :model="form" v-on:submit.prevent="beforeSubmit" :rules="rules" >
  
  <div class="row" style="margin-top:16px;">
    <div class="col s12 m9 offset-m1m" >   
      <!--<h3 style="margin-bottom:0;">Reserved area</h3>
        <div style="margin-bottom:12px;"> </div>
        -->
         <el-form-item class="no-label" prop="email">
         <el-input placeholder="Email" v-model.trim="form.email" auto-complete="off"></el-input>
         </el-form-item>
         <el-form-item class="no-label" prop="password">
         <el-input placeholder="Password" type="password" v-model.trim="form.password" auto-complete="off"  ></el-input>
         </el-form-item>

         <div class="row">
            <div class="col s6 offset-s6"><el-button type="success" v-on:click="beforeSubmit" style="width:100%;">Login</el-button></div>
         </div>

         <br />
         <hr />
    </div>
  </div>
  
  <div class="row pad">
    <div class="col s12 m4m offset-m1m">
        <div style="height:160px;">
        <h3 style="margin-top:16px;">Forgotten your password?</h3>
        If you have forgotten your password, insert your email and click on “Request password” <br />&#160;
        <el-form-item class="no-label" prop="recovery">
        <el-input  placeholder="Email" v-model.trim="form.recovery" auto-complete="off"></el-input>
        </el-form-item>
        </div>
        <div class="row">
          <div class="col s12"><el-button type="primary" v-on:click="getPassword" style="width:100%;">Request Password</el-button></div>
        </div>
    </div>
    
    <div class="col s12 m4m">
        <div style="height:160px;">
          <h3 style="margin-top:16px;">New registration?</h3>
        If you do not have personal credentials to access the system and you want to register, click on “New Registration” 
        </div>
        <div class="row">
          <div class="col s12"><el-button type="primary" v-on:click="newUser" style="width:100%;">New Registration</el-button></div>
        </div>
    </div>
  </div>

  </el-form>

</div>
</template>

<script>
import emailRecovery from './Email-recovery.vue'
export default {
  name: 'login',
   created () {
    console.log("Created Login.vue")
    console.log(this.$route.meta)
    this.$teras.page.title = "Login"
    if(this.$teras.app.auth == true)
      this.$router.push('/home')
    if(this.$route.params.tipo=='new' || this.$route.meta.newuser)
      this.newUser()

  },
  data() {
    return {
      termini:false,
      form: {
        email: '',
        password: '',
        recovery:''
      },
      rules: {
        email: [
          { required: true, message: 'Email address is mandatory', trigger: 'blur' }
        ],
        password: [
          { required: true, message: 'Password is mandatory', trigger: 'blur' }
        ]        
      }
    };
  },
  methods: {
    newUser(){
      this.$contatto.profile.new().then((response) =>  {
        this.$contatto.profile.row.password = this.$teras.random()
        this.$teras.app.routeInitial = '/contatto-profile'
        this.$router.push('/contatto-profile') 
      })
    },
    getPassword() {
      if(this.form.recovery!=''){
        this.$axios.query('fetchAll','SELECT * FROM contatto WHERE email = →recovery',this.form).then((data) => {
          if(data.result.length == 1 && data.result[0].id > 0){
            var html = this.$teras.renderVue(emailRecovery,{contatto:data.result[0],evento:this.$evento.profile.row})
            this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'Access credentials: '+this.$evento.profile.row.nome,to:data.result[0].email,body:html}).then((data) => {
              console.log("Email con invio credenziali inviata")
            }).catch((error) => {
              console.log("Errore nell'invio della email con le credenziali")
              console.log(error)
            })


            
            var args = {idContatto: data.result[0].id, lingua:'ita'}
            this.$alert('We have sent you access credentials to your email address', 'Password recovery', {confirmButtonText: 'Close' })

          }else{
            var msg = (data.result.length > 1) ? "Your email address is associated with multiple contacts, please contact the secretariat to solve the problem!" : "We are sorry, your email address has not been registered in this system."
            this.$alert(msg, "ATTENTION" ,{confirmButtonText: 'Chiudi' })
          }
        })

      }else{
        this.$notify.error({title: 'Errore',message: "Email is mandatory"})
      }
      
    },
    beforeSubmit(event) {
      event.preventDefault()
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.goSubmit()
        } else {
          return false;
        }
      });
    },
    goSubmit() {
      this.$axios.query('fetchRow','SELECT * FROM contatto WHERE email = →email AND password=→password',this.form).then((data) => {
        console.log("LOGIN CHECK")
        if(data.result.id > 0){
          this.$teras.utente = data.result
          this.$teras.app.routeInitial = this.$teras.app.routeAuth
          this.$teras.event.emit('login','/home')
        }else{
          this.$notify.error({title: 'Errore',message: "The credentials entered are not valid!"})
        }
      })
    }
  }
}
</script>
<style>
.login {
  margin: 0 auto;
  max-width: 700px;
}
.page-login{
  background:#fff;
  width: 100%;
}.login .el-form-item__content{
  margin:0 !important;

}
</style>
